import React, { useEffect, useState } from "react";
import styles from "./DashPage2.module.scss";
import { userDetailsAPICall } from "../../../../Shared/APIcalls";

export default function DashPage2() {
  const [userData, setUserData] = useState({
    request_time: "",
    uname: "",
    m_num: "",
    exarr: ["NFO", "NSE", "BSE", "BFO", "NIPO"],
    prarr: [
      {
        prd: "I",
        s_prdt_ali: "IntraDay",
        exch: ["NSE", "BSE", "NFO", "BFO"],
      },
      {
        prd: "C",
        s_prdt_ali: "Delivery",
        exch: ["NSE", "BSE", "NIPO"],
      },
      {
        prd: "M",
        s_prdt_ali: "Regular",
        exch: ["NFO", "BFO"],
      },
    ],
    orarr: ["MKT", "LMT", "SL-LMT", "SL-MKT", "DS"],
    brkname: "",
    uid: "",
    brnchid: "",
    email: "",
    actid: "",
    uprev: "",
    stat: "",
  });

  useEffect(() => {
    userDetailsAPICall()
      .then((response: any) => {
        console.log("response", response.data);
        setUserData(response.data);
      })
      .catch((error: any) => {});
  }, []);

  return (
    <div className={styles.mainwrapper}>
      <div className={styles.content}>
        <p className={styles.heading}>Hello, {userData.uname}!</p>
        <p className={styles.para}>Welcome to Firstock Connect</p>
      </div>
      <div className={styles.top}>
        <div className={styles.bottomtop}>
          <p className={styles.details}>Profile Details</p>
        </div>
        <div className={styles.bottomdiv}>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>User Name</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.uname}</p>
            </div>
          </div>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>Email</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.email}</p>
            </div>
          </div>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>Segments</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.exarr.join(", ")}</p>
            </div>
          </div>
        </div>
        <div className={styles.bottomdiv}>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>Mobile Number</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.m_num}</p>
            </div>
          </div>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>Order Type</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.orarr.join(", ")}</p>
            </div>
          </div>
          <div className={styles.main}>
            <div>
              <p className={styles.key}>UserID</p>
            </div>
            <div className={styles.copy1}>
              <p className={styles.numbers}>{userData.uid}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.down}>
        <div>
          <p
            className={styles.downpara}
            style={{ fontSize: "15px", fontWeight: 600, marginBottom: "10px" }}
          >
            Exchanges{" "}
          </p>
          <p className={styles.downpara}>BSE - BSE Equity</p>
          <p className={styles.downpara}>NSE - NSE Equity</p>
          <p className={styles.downpara}> NFO - NSE Future and Options</p>
        </div>
        {/* <hr className={styles.horizontalrule} /> */}
        <div
         
          className={styles.horizontalline}
        ></div>

        {/* <span className={styles.divider}></span> */}
        <div>
          <p
            className={styles.downpara}
            style={{ fontSize: "15px", fontWeight: 600, marginBottom: "10px" }}
          >
            Products{" "}
          </p>
          <p className={styles.downpara}>C - Cash & Carry for equity</p>
          <p className={styles.downpara}>I - Intraday</p>
          <p className={styles.downpara}>M – Regular</p>
        </div>
        <div
        className={styles.horizontalline}
        ></div>
        <div>
          <p
            className={styles.downpara}
            style={{ fontSize: "15px", fontWeight: 600, marginBottom: "10px" }}
          >
            Price Types{" "}
          </p>
          <p className={styles.downpara}>MKT - Market Order </p>
          <p className={styles.downpara}>LMT - Limit Order</p>
          <p className={styles.downpara}>SL-LMT - Stop Loss Limit Order</p>
          <p className={styles.downpara}>SL-MKT - Stop Loss Market Order</p>
        </div>
      </div>
    </div>
  );
}
